var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbitation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.852 8a2 2 0 0 1 1.995 2.143l-.714 10A2 2 0 0 1 20.138 22H3.861a2 2 0 0 1-1.995-1.857l-.714-10A2 2 0 0 1 3.148 8zm-8.851 2a3 3 0 0 0-3 3c0 .902.4 1.708 1.029 2.258-2.038.548-3.64 1.923-4.256 3.66-.198.56.272 1.082.866 1.082h10.721c.594 0 1.064-.522.865-1.082-.615-1.737-2.217-3.111-4.255-3.66A3 3 0 0 0 15 13a3 3 0 0 0-3-3"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 5,
  fill: "currentColor",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 2,
  x: 5,
  y: 2,
  fill: "currentColor",
  rx: 1
})));
export default SvgInbitation;